import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  min-height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  justify-content: space-between;
  background-color: #363636;
  font-family: Montserrat-Medium;
  fill: #fff;

  input,
  textarea {
    font-size: 16px;
  }

  h1 {
    color: #fff;
    text-align: left;
    width: 90%;
    font-size: 18px;
    margin-bottom: 10px;
  }

  p {
    color: #fff;
    text-align: left;
    width: 92%;
    font-size: 14px;
  }
`;

export const ViewMax = styled.div`
  width: 100%;
  max-width: 500px;
  position: relative;
  display: flex;
  flex: 1;
  padding: 25px 0;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img`
  width: 90px;
  margin: 50px 0;
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 90%;
  margin-bottom: 5px;
  justify-content: space-between;
  text-align: center;
  font-family: "Montserrat-Regular";

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 5px 5px;
    color: #fff;
    font-family: "Montserrat-Medium";
  }

  .ant-input-group-addon {
    background-color: #fff;
  }
`;

export const ViewRow = styled.div`
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ViewPartner = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #282828;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;

  img {
    width: 90px;
    height: 90px;
    border-radius: 90px;
    margin-right: 15px;
  }

  div {
    width: 100%;
  }
  p {
    flex: 1;
    color: #fff;
    margin-bottom: 5px;
    font-size: 14px;
    font-family: Montserrat-Medium;
  }
  button {
    margin-top: 5px;
    border-radius: 50px;
    height: 25px;
  }
`;

export const ViewProfile = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #282828;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;

  img {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    margin-right: 20px;
  }

  div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  p {
    width: 100%;
    color: #fff;
    margin-bottom: 5px;
    padding-left: 5px;
    font-size: 14px;
    font-family: Montserrat-Medium;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limita a 2 linhas */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    width: 100%;
    color: #fff;
    padding-left: 5px;
    font-size: 12px;
    font-family: Montserrat-Regular;
  }

  button {
    margin-top: 0px;
    border-radius: 50px;
    height: 25px;
    margin-bottom: 8px;
  }
`;

export const ButtonBack = styled.button`
  height: 40px;
  border-radius: 40px;
  width: 40px;
  display: flex;
  padding: 0 0 0 1px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
`;

export const ViewStats = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-around;
  background-color: #282828;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  div {
    text-align: center;
    p {
      text-align: center;
      width: 100%;
      margin: 0;
    }
    span {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
  }
`;
